// Module
var code = `<div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-center">
    <div class="HOA-misc-guidedSteps__flex-child HOA-make-guidedSteps_label--padding">
        <label tid="firstNameLabel" id="firstNameLabel" class="u-fontBold">
            First Name
        </label>
    </div>
    <div *ngIf="showFirstNameInput"
         [ngClass]="{ 'is-invalid': firstNameError }"
         class="Field HOA-misc-guidedSteps__flex-child">
        <input type="text"
               class="Input"
               id="firstNameInput"
               tid="firstNameInput"
               name="firstName"
               maxlength="25"
               [(ngModel)]="personalInfoData.homeowner.firstName"
               (change)="firstName()"
               required
               aria-invalid="{{firstNameError || !personalInfoData.homeowner.firstName}}"
               attr.aria-describedby="{{firstNameError && 'firstName-error' || undefined }}" >
        <span class="Field-error" tid="firstName-error" id="firstName-error">Please enter your first name.</span>
    </div>
    <div *ngIf="!showFirstNameInput" class="Field HOA-misc-guidedSteps__flex-child">
        <span tid="firstName" id="firstName">{{personalInfoData.homeowner.firstName}}</span>
    </div>
</div>
<div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-center">
    <div class="HOA-misc-guidedSteps__flex-child HOA-make-guidedSteps_label--padding">
        <label tid="lastNameLabel" id="lastNameLabel" for="lastName" class="u-fontBold">
            Last Name
        </label>
    </div>
    <div *ngIf="showLastNameInput"
         [ngClass]="{ 'is-invalid': lastNameError }"
         class="Field HOA-misc-guidedSteps__flex-child">
        <input type="text"
               class="Input"
               id="lastNameInput"
               tid="lastNameInput"
               name="lastName"
               maxlength="35"
               [(ngModel)]="personalInfoData.homeowner.lastName"
               (change)="lastName()"
               required
               aria-invalid="lastNameError"
               attr.aria-describedby="{{lastNameError && 'lastName-error' || undefined }}">
        <span class="Field-error" tid="lastName-error" id="lastName-error">Please enter your last name.</span>
    </div>
    <div *ngIf="!showLastNameInput" class="Field HOA-misc-guidedSteps__flex-child">
        <span tid="lastName" id="lastName">{{personalInfoData.homeowner.lastName}}</span>
    </div>
</div>

<app-email-easy [personalInfoData]="personalInfoData"  (invalidCheck)="onInvalidCheck(\$event)"></app-email-easy>

<div *ngIf="personalInfoData.emailAddressExists &&
                    personalInfoData.isHoaHomeowner &&
                    personalInfoData.registeredUserEnabled"
     class="u-mB7 u-mH4 u-bgBlueLightest u-rounded u-pA4 HOA-flextable-component__cell&--100-field">
    <div tid="registeredUserLabel" id="registeredUserLabel" class="HOA-guest-payment-header-light u-pB3">
        Registered User
    </div>
    <div class="HOA-flex-component HOA-guest-payment-sm-col-lg-row HOA-guest-payment-register-flex">
        <div class="HOA-font-light HOA-sm-pB3 HOA-guest-payment-flex-text u-mR2">{{registeredUserMessage}}</div>
        <button tid="login"
                class="HOA-splash-buttons-container__button Button Button--blue"
                type="button"
                (click)="login()">
            Login
        </button>
    </div>
</div>
<div *ngIf="personalInfoData.registration && !personalInfoData.accountActive"
     class="u-mB7 u-mH4 u-bgBlueLightest u-rounded u-pA4 HOA-flextable-component__cell&--100-field">
    <div tid="inactiveUserLabel" id="inactiveUserLabel" class="HOA-guest-payment-header-light u-pB3">
        Inactive User
    </div>
    <div class="HOA-flex-component HOA-guest-payment-sm-col-lg-row HOA-guest-payment-register-flex">
        <div class="HOA-font-light HOA-sm-pB3 HOA-guest-payment-flex-text u-mR2">
            Thank you for registering. Your account is not yet active.  Please try again in 24 hours to
            complete the activation process. If you need to make a payment immediately, please select Pay
            Assessments. We apologize for the delay.
        </div>
    </div>
</div>
<div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-center">
    <div class="HOA-misc-guidedSteps__flex-child HOA-make-guidedSteps_label--padding">
        <label tid="phoneNumberLabel" id="phoneNumberLabel" class="u-fontBold" for="input-text-phone-number">
            Phone Number
        </label>
    </div>
    <div *ngIf="showPhoneNumberInput"
         class="Field HOA-misc-guidedSteps__flex-child"
         [ngClass]="{ 'is-invalid': phoneNumberError }"
         aria-invalid="phoneNumberError"
         attr.aria-describedby="{{phoneNumberError && 'phoneNumber-error' || undefined }}">
        <div class="Field-addonBox">
            <div class="Field-addon HOA-Field-addon HOA-Field-phone-select Select">
                <!-- this text is hidden but needed for accessibility -->
                <label for="countryCode" class="hide">
                    Country Code
                </label>
                <select id="countryCode"
                        tid="countryCode"
                        [(ngModel)]="countryCode"
                        (change)="onCountryCodeChange()">
                    <option *ngFor="let code of countryCodes" [ngValue]="code">
                        {{code.country + ' (+' + code.value + ')'}}
                    </option>
                </select>
                <span class="Select-arrow"></span>
            </div>

            <input type="text"
                   class="Input HOA-Field-phone-input"
                   id="input-text-phone-number"
                   tid="phoneNumberInput"
                   #phoneNumberInput
                   phone-number  [countryCode]="countryCode"
                   [ngClass]="{ 'is-invalid': phoneNumberError }"
                   [(ngModel)]="personalInfoData.homeowner.contactInformation.phones[0].value"
                   (blur)="checkPhoneNumberLength()"
                   required
                   autocapitalize="off"
                   autocomplete="off"
                   autocorrect="off"
                   spellcheck="false"/>
            <span class="Field-error" tid="phoneNumber-error" id="phoneNumber-error">
                        Please enter a valid phone number.
                    </span>
        </div>
    </div>
    <div *ngIf="!showPhoneNumberInput" class="Field HOA-misc-guidedSteps__flex-child">
        <span tid="phoneNumber" id="phoneNumber">{{personalInfoData.homeowner.contactInformation.phones[0].value}}</span>
    </div>
</div>`;
// Exports
module.exports = code;